export const USER_MANAGEMENT_TABLE_SUCCESS = 'USER_MANAGEMENT_TABLE_SUCCESS';
export const USER_MANAGEMENT_TABLE_FAILURE = 'USER_MANAGEMENT_TABLE_FAILURE';

export const VOLUNTEER_ADMIN_DASHBOARD_SUCCESS = 'VOLUNTEER_ADMIN_DASHBOARD_SUCCESS';
export const VOLUNTEER_ADMIN_DASHBOARD_FAILURE = 'VOLUNTEER_ADMIN_DASHBOARD_FAILURE';